import { Box, Divider, IconButton, Menu, Typography } from '@mui/material'
import React from 'react'
import '../../Pages/Devices/devices.css'
import { ArrowRightAlt, MenuOutlined } from '@mui/icons-material'
const DeviceRow = ({ type,server,el,i,setOpen,setTempEditData }) => {
  return (
    <>
   
          <div className='queuesContainer' >
            <span className='queueNumber' style={{ borderColor: (i + 1) % 2 === 0 ? "forestgreen" : "#2065d1" }}>{i + 1}</span>
            <Box sx={{ color: "black" }}>
              {
                type === "server" ? 
                <>
                 <Typography display={"flex"} flexWrap={"wrap"} alignItems={"center"} gap={1} fontSize={20}>Code <ArrowRightAlt /> <strong>{server.deviceCode}</strong></Typography>
            <Typography display={"flex"} flexWrap={"wrap"} alignItems={"center"} gap={1} fontSize={20}>Queue <ArrowRightAlt />  <strong style={{ whiteSpace: "break-spaces" }}>{server.queue}</strong></Typography>
            
                </> :
                <>
                
              <Typography display={"flex"} alignItems={"center"} flexWrap={"wrap"} gap={1} fontSize={18}>Code <ArrowRightAlt /> <strong>{el.deviceCode}</strong></Typography>
              <Typography display={"flex"} alignItems={"center"} flexWrap={"wrap"} gap={1} fontSize={18}>Queue <ArrowRightAlt />  <strong>{el.queue}</strong></Typography>
            
                </>
              }</Box>
            <IconButton onClick={(event)=>{setOpen(event.currentTarget);setTempEditData(type==="server" ? server : el)}}><MenuOutlined sx={{color:"black"}}/></IconButton>
          </div>
      <Divider/>
    </>

  )
}

export default DeviceRow